var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3C11.9069 3 11 3.90694 11 5V9H5C3.90694 9 3 9.90694 3 11V19C3 20.0931 3.90694 21 5 21H19C20.0931 21 21 20.0931 21 19V5C21 3.90694 20.0931 3 19 3H13ZM13 5H19V19H5V11H13V5ZM15 8V12C15 13.1167 14.1167 14 13 14H10V12L7 15L10 18V16H13C15.1973 16 17 14.1973 17 12V8H15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.95f9b7183ac81d9c9b4b722eb076c7b5.svg";
export { ForwardRef as ReactComponent };